/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Merge_With_LabelInputs */



/**
* | output |
* | --- |
* | "Merge With Speaker:" |
*
* @param {Speaker_Manager_Merge_With_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_merge_with_label = /** @type {((inputs?: Speaker_Manager_Merge_With_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Merge_With_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner avec le locuteur :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit Sprecher zusammenführen:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci con l'oratore:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Совместить со спикером:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionarse con el orador:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("与演讲者合并：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーと結合:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर के साथ मर्ज करें:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Unir com o orador:")
	return /** @type {LocalizedString} */ ("Merge With Speaker:")
});